import { createApi } from '@reduxjs/toolkit/query/react';
import service from './Service';

// baseQuery que reutiliza Service.js para conservar auth + interceptor 401.
const serviceBaseQuery =
  () =>
  async ({ url, params }) => {
    const res = await service.get(url, params);

    // Service.get devuelve undefined si la petición falló (ya notificó el error).
    if (!res) {
      return { error: { status: 'FETCH_ERROR', message: 'request failed' } };
    }
    // Envoltura de la API: { ok, data }.
    if (res.data?.ok === false) {
      return { error: { status: 'API_ERROR', data: res.data } };
    }
    return { data: res.data };
  };

export const lookupApi = createApi({
  reducerPath: 'lookupApi',
  baseQuery: serviceBaseQuery(),
  keepUnusedDataFor: 3600, // cache de cliente 1h
  tagTypes: ['Roles', 'CloudKey', 'Routers'],
  endpoints: (build) => ({
    getModelsLookup: build.query({
      query: () => ({ url: 'models/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getVersionsLookup: build.query({
      query: () => ({ url: 'versions/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getTenantsLookup: build.query({
      query: () => ({ url: 'tenants/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getPoolsLookup: build.query({
      query: () => ({ url: 'pools/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getRolesLookup: build.query({
      query: () => ({ url: 'roles/lookup' }),
      transformResponse: (response) => response?.data ?? [],
      providesTags: ['Roles'],
    }),
    getTrackerModelsLookup: build.query({
      query: () => ({ url: 'v0/tracker/models/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getCloudKey: build.query({
      query: (uuid) => ({ url: `users/${uuid}` }),
      transformResponse: (response) => response?.data?.[0]?.api_key_cloud ?? null,
      providesTags: ['CloudKey'],
    }),
    getModemTypesLookup: build.query({
      query: () => ({ url: 'modems/types/lookup' }),
      transformResponse: (response) => response?.data ?? [],
    }),
    getRoutersLookup: build.query({
      query: () => ({ url: 'routers/lookup' }),
      transformResponse: (response) => response?.data ?? [],
      providesTags: ['Routers'],
    }),
  }),
});

export const invalidateRoutersLookup = () => lookupApi.util.invalidateTags(['Routers']);

export const {
  useGetModelsLookupQuery, 
  useGetVersionsLookupQuery,
  useGetTenantsLookupQuery,
  useGetPoolsLookupQuery,
  useGetRolesLookupQuery,
  useGetTrackerModelsLookupQuery,
  useGetCloudKeyQuery,
  useGetModemTypesLookupQuery,
  useGetRoutersLookupQuery
} = lookupApi;
